document.addEventListener('DOMContentLoaded', function() {
  const atcBtns = document.querySelectorAll('.js-add-to-cart');

  atcBtns.forEach(function(btn) {
    btn.addEventListener('click', function(event) {
      event.preventDefault();
      this.setAttribute('disabled', 'true');
      const variantId = this.getAttribute('data-id');
      const sellingPlanId = this.getAttribute('data-selling-plan-id');
      const quantity = parseInt(this.getAttribute('data-quantity')) || 1;
      const discountCode = this.getAttribute('data-discount');

      this.querySelector('.loader')?.classList.add('active');

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(() => {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: quantity,
              ...(sellingPlanId && { selling_plan: sellingPlanId })
            }]
          })
        });
      })
      .then(response => response.json())
      .then(() => {
        let checkoutUrl = '/checkout';
        if (discountCode) {
          const formattedDiscount = discountCode
              .split(' ')
              .filter(code => code.trim() !== '')
              .join(',');
          checkoutUrl += `?discount=${encodeURIComponent(formattedDiscount)}`;
        }
        window.location.href = checkoutUrl;
      })
      .catch(error => {
        console.error('Error processing cart:', error);
        this.querySelector('.loader')?.classList.remove('active');
      });
    });
  });

  initCarousels();

  function initCarousels() {
    new Swiper(".mm-four-columns .swiper", {
      slidesPerView: 1.5,
      scrollbar: {
        el: '.mm-four-columns .swiper-scrollbar',
      },
      navigation: {
        nextEl: '.mm-four-columns .mm-swiper-button-next',
        prevEl: '.mm-four-columns .mm-swiper-button-prev',
      },
      spaceBetween: 15,
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 15,
        }
      },
    });

    new Swiper(".mm-three-columns .swiper", {
      slidesPerView: 1.5,
      spaceBetween: 15,
      navigation: {
        nextEl: '.mm-three-columns .mm-swiper-button-next',
        prevEl: '.mm-three-columns .mm-swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 15,
        }
      },
    });
  }

  initToolTips();

  function initToolTips() {
    const template = document.querySelector('template[data-tooltip-content]');
    if (!template) return;
    const container = document.createElement('div')
    container.appendChild(document.importNode(template.content, true))

    tippy('[data-tooltip-button]', {
      content: container.innerHTML,
      theme: 'tomato',
      arrow: true,
      placement: 'top',
      allowHTML: true,
    })
  }
});